// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "insurance-3w3Pl";
var _4 = "selected-5qFV5";
var _5 = "insurance__header-1d9Xv";
var _6 = "insurance__content-1hZBE";
var _7 = "insurance__money-1_LTb";
var _8 = "insurance__button-3l8fq";
var _9 = "insurance__button_selected-1BOBj";
export { _1 as "__esModule", _2 as "mobile", _3 as "insurance", _4 as "selected", _5 as "insurance__header", _6 as "insurance__content", _7 as "insurance__money", _8 as "insurance__button", _9 as "insurance__button_selected" }
export default { "__esModule": _1, "mobile": _2, "insurance": _3, "selected": _4, "insurance__header": _5, "insurance__content": _6, "insurance__money": _7, "insurance__button": _8, "insurance__button_selected": _9 }
